import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/site';
import { dramaCategories } from '@/mocks/dramas';

const year = new Date().getFullYear();

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-100 mt-auto">
      <div className="w-full px-4 md:px-8 pt-12 md:pt-16 pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-file-shield-2-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold tracking-wide text-background-50">
                {siteInfo.brand}
              </span>
            </div>
            <p className="text-sm leading-relaxed text-background-200/80 max-w-sm">
              {siteInfo.intro}
            </p>
            <p className="mt-5 text-sm text-accent-300 flex items-center gap-2">
              <i className="ri-mail-line"></i>
              <a href={`mailto:${siteInfo.email}`} className="hover:text-accent-200 transition-colors">
                {siteInfo.email}
              </a>
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4 tracking-wide">
              <a href="/" className="hover:text-accent-300 transition-colors">
                站内导航
              </a>
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/" className="text-background-200/80 hover:text-background-50 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/dramas" className="text-background-200/80 hover:text-background-50 transition-colors">
                  短剧档案库
                </Link>
              </li>
              <li>
                <Link to="/#method" className="text-background-200/80 hover:text-background-50 transition-colors">
                  我们怎么核对
                </Link>
              </li>
              <li>
                <Link to="/#faq" className="text-background-200/80 hover:text-background-50 transition-colors">
                  常见问题
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-background-200/80 hover:text-background-50 transition-colors">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4 tracking-wide">
              题材分区
            </h4>
            <ul className="space-y-2.5 text-sm">
              {dramaCategories.map((cat) => (
                <li key={cat}>
                  <Link
                    to={`/dramas?cat=${encodeURIComponent(cat)}`}
                    className="text-background-200/80 hover:text-background-50 transition-colors"
                  >
                    {cat}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4 tracking-wide">
              内容说明
            </h4>
            <p className="text-sm leading-relaxed text-background-200/80">
              本站内容基于公开报道与片方声明整理，仅用于信息比对与观众参考，不构成对任何个人、单位的事实认定或法律意见。
            </p>
            <Link
              to="/about"
              className="mt-4 inline-flex items-center gap-1.5 text-sm text-accent-300 hover:text-accent-200 transition-colors"
            >
              了解内容原则
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-background-200/60">
          <p>
            © {year} {siteInfo.brand}. 内容整理自公开信源，转载请标注出处。
          </p>
          <p className="font-label tracking-wider">SINCE {siteInfo.since} · 内容核对以页面标注日期为准</p>
        </div>
      </div>
    </footer>
  );
}